import clsx from "clsx";
import shape from "../../assets/img/shapes/line-shape-02.webp";


const LineShape02 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-line-shape-02", props.className)}>
            <img src={shape} alt="rmdr-line-shape-02" loading="lazy" width={240} height={234} />
        </div>
    )

}

export default LineShape02;
